import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { cdiscManagementService } from "../../../APIServices/CDISC/cdiscManagementService";

const UpdateTMapMetadata = ({
  Show,
  Hide,
  Title,
  getStudyCDISCTMap,
  tMapData,
  studyId,
}) => {
  const [domain, setDomain] = useState("");
  const [pattern, setPattern] = useState("");
  const [testCD, setTestCD] = useState("");
  const [testName, setTestName] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);

  useEffect(() => {
    if (tMapData) {
      setDomain(tMapData?.domain || "");
      setPattern(tMapData?.pattern || "");
      setTestCD(tMapData?.testCD || "");
      setTestName(tMapData?.testName || "");
    }
  }, [tMapData]);

  const updateStudyCDISCTMap = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to update this tmap?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {};
        userData.id = tMapData?._id;
        userData.domain = domain;
        userData.pattern = pattern;
        userData.testCD = testCD;
        userData.testName = testName;
        userData.studyId = studyId;
        let data = await cdiscManagementService.updateStudyCDISCTMap(userData);
        if (data?.statusCode === 200) {
          getStudyCDISCTMap();
          Hide();
        }
        setButtonLoader(false);
      }
    });
  };

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <Form.Group className="mb-1">
          <Form.Label className="mb-1 fw-bold">
            Domain <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            required
            type="text"
            value={domain}
            onChange={(e) => setDomain(e.target.value)}
            placeholder="Enter Domain"
          />
        </Form.Group>
        <Form.Group className="mb-1">
          <Form.Label className="mb-1 fw-bold">Pattern</Form.Label>
          <Form.Control
            type="text"
            value={pattern}
            onChange={(e) => setPattern(e.target.value)}
            placeholder="Enter Pattern "
          />
        </Form.Group>
        <Form.Group className="mb-1">
          <Form.Label className="mb-1 fw-bold">Test CD</Form.Label>
          <Form.Control
            type="text"
            value={testCD}
            onChange={(e) => setTestCD(e.target.value)}
            placeholder="Enter TestCD"
          />
        </Form.Group>
        <Form.Group className="mb-1">
          <Form.Label className="mb-1 fw-bold">Test Name</Form.Label>
          <Form.Control
            type="text"
            value={testName}
            onChange={(e) => setTestName(e.target.value)}
            placeholder="Enter Test Name"
          />
        </Form.Group>
      </Offcanvas.Body>

      <div className="p-2 bg-light border-top shadow-sm hstack justify-content-end gap-2">
        <button
          onClick={updateStudyCDISCTMap}
          className="updateProfile"
        >
          {buttonLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm" /> Updating...
            </div>
          ) : (
            Title
          )}
        </button>
      </div>
    </Offcanvas>
  );
};

export default UpdateTMapMetadata;
